var _circle, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejectedAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#1C74D0",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_829_2557)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 20.0001,
    r: 15.381,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0833 10.146C16.6786 10.146 14.7291 12.0954 14.7291 14.5002C14.7291 16.9049 16.6786 18.8543 19.0833 18.8543C21.4881 18.8543 23.4375 16.9049 23.4375 14.5002C23.4375 12.0954 21.4881 10.146 19.0833 10.146ZM16.1041 14.5002C16.1041 12.8548 17.4379 11.521 19.0833 11.521C20.7286 11.521 22.0625 12.8548 22.0625 14.5002C22.0625 16.1455 20.7286 17.4793 19.0833 17.4793C17.4379 17.4793 16.1041 16.1455 16.1041 14.5002Z",
    fill: "#1C74D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 20.2295C13.9286 20.2295 11.9791 22.1789 11.9791 24.5837C11.9791 26.9884 13.9286 28.9378 16.3333 28.9378H21.8333C22.213 28.9378 22.5208 28.63 22.5208 28.2503C22.5208 27.8706 22.213 27.5628 21.8333 27.5628H16.3333C14.6879 27.5628 13.3541 26.229 13.3541 24.5837C13.3541 22.9383 14.6879 21.6045 16.3333 21.6045H21.8333C22.213 21.6045 22.5208 21.2967 22.5208 20.917C22.5208 20.5373 22.213 20.2295 21.8333 20.2295H16.3333Z",
    fill: "#1C74D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1531 23.3474C28.4216 23.079 28.4216 22.6437 28.1531 22.3752C27.8846 22.1067 27.4493 22.1067 27.1808 22.3752L25.7224 23.8336L24.264 22.3752C23.9955 22.1067 23.5602 22.1067 23.2917 22.3752C23.0232 22.6437 23.0232 23.079 23.2917 23.3475L24.7501 24.8058L23.2917 26.2642C23.0232 26.5327 23.0232 26.9681 23.2917 27.2366C23.5602 27.505 23.9955 27.505 24.264 27.2366L25.7224 25.7781L27.1808 27.2366C27.4493 27.505 27.8846 27.505 28.1531 27.2366C28.4216 26.9681 28.4216 26.5327 28.1531 26.2642L26.6946 24.8058L28.1531 23.3474Z",
    fill: "#1C74D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_829_2557",
    x: 0.618896,
    y: 0.619141,
    width: 38.762,
    height: 38.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.454902 0 0 0 0 0.815686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_829_2557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_829_2557",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedAccount);
export default __webpack_public_path__ + "static/media/rejected-account.8948fcb15d7f3bd902e6d4c6d7bd7988.svg";
export { ForwardRef as ReactComponent };